import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Menu, Segment } from 'semantic-ui-react';
import { store, useStore } from '../../app/stores/store';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { v4 as uuid } from 'uuid';
import {
  templateL2Info,
} from '../../app/stores/CRMStore/types';
import { roleBasedCardHiddenForsubtask, roleBasedCardHiddenForTask, subtaskTypes, taskTypes } from '../../app/stores/NFAI_Restoration_Smartflow/types';
import { useParams } from 'react-router-dom';
import InputAndButtonComponent from './InputAndButtonComponent';
import SmarttrackerComponents from './SmarttrackerComponents';
import DynamicTableComponentForMetaData from '../DynamicTable/DynamicTableComponentForMetaData';
const NFAI_Restoration_SmartFlow = () => {
    const {
        NFAI_Restoration_SmartflowsStore,
        dashboardStore,
        TrackingReportStore,
        sidebarStore,
        userStore:{user}
    } = useStore();
    const {handleTableDetails,handleTemplateL2,handleTemplateL3,selectedItems,taskDetails,SubtaskDetails,subtaskCompoent,titileInformation,statusButtonShow,resetButtons,resetDropdown,dropdownDetails } = NFAI_Restoration_SmartflowsStore
    const params = useParams();
    const { templateId } = params as any;
  const [pageNumber, setPageNumber] = useState(1);
  useEffect(()=>{
    resetButtons();
    subtaskCompoent.elements = [];
    subtaskCompoent.elementCopy = [];
     // eslint-disable-next-line
  },[sidebarStore.sidebar.open])
  useEffect(()=>{
  NFAI_Restoration_SmartflowsStore.templateId = templateId as string
   (async () => {
     let result = await handleTemplateL2(params?.templateId || '') || [];
     const newCurrTask = (roleBasedCardHiddenForTask(user?.roleName || '') || []).map((task:string) => {
       const found = result.find((item: taskTypes) => item.task === task);
       return found ? { task: found.task, count: found.count } : { task, count: 0 };
      });
      NFAI_Restoration_SmartflowsStore.taskDetails = newCurrTask;
    const selectedTask = newCurrTask?.filter((s:taskTypes) => s.count !== 0);
    const subtaskResponse = await handleTemplateL3(params?.templateId || '',selectedTask?.[0]?.task || '');
    const newCurrsubtask = (roleBasedCardHiddenForsubtask(selectedTask[0]?.task || '') || []).map((subtask:string) => {
      const found = subtaskResponse.find((item:subtaskTypes) => item?.subtask === subtask || '');
      return found ? { subtask: found.subtask, count: found.count } : { subtask, count: 0 };
    });
    NFAI_Restoration_SmartflowsStore.SubtaskDetails = newCurrsubtask;
    const selectedSubTask = newCurrsubtask?.filter((s:subtaskTypes) => s.count !== 0);
      NFAI_Restoration_SmartflowsStore.selectedItems = {
        ...NFAI_Restoration_SmartflowsStore.selectedItems,
        task: selectedTask[0].task || 'Full Restoration',
        subtask: selectedSubTask[0].subtask || 'Restoration'
      }
      getNewDetails(1,selectedTask?.[0]?.task || 'Full Restoration',selectedSubTask?.[0]?.subtask || 'Restoration')
  })();
   // eslint-disable-next-line 
},[])

useEffect(()=>{
  if (dashboardStore.dashboard.setTagTablePageNumber === 1)  setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);  
},[dashboardStore.dashboard.setTagTablePageNumber])

  const getNewDetails = async (pageNumber?: number, task?:string,subtask?: string) => {
     await resetDropdown();
      TrackingReportStore.bindComponent.model = false;
      const searchData: Record<string, string> = {
        ...dashboardStore.dashboard.searchfilterparams,
        taskName: task || selectedItems.task || 'Cutlist Restoration',
        subtaskName: subtask || selectedItems.subtask || 'Restoration',
        filmTitle: '',
        reelName: '',
        empId: store.userStore.user?.roleName !== 'Admin' &&
        !store.commonStore.filterModeOne.includes('GA01')
          ? store?.userStore?.user?.displayName 
          : '',
        empName: ''
      }
      handleTableDetails(pageNumber || 1,searchData);
    };
  
  const clickTaskHandler = async (name: string) => {
    const subtaskResponse = await handleTemplateL3(templateId,name);
    const transformedDetails = subtaskResponse?.map((detail:subtaskTypes) => ({
      subtask: detail.subtask,
      count: detail.count,
    }));
    NFAI_Restoration_SmartflowsStore.SubtaskDetails = transformedDetails;
    dashboardStore.setReportsPageNum(1);
    const selectedSubTask = subtaskResponse.filter((s:subtaskTypes) => s.count !== 0);
    NFAI_Restoration_SmartflowsStore.selectedItems = { task: name || selectedItems.task || '', subtask : selectedSubTask?.[0]?.subtask || ''}
    getNewDetails(1,name || '',selectedSubTask?.[0]?.subtask || '')
  };
  
  const paginateFunction = (e: number) => {
  const params = {
    taskName: selectedItems.task || 'Cutlist Restoration',
    subtaskName: selectedItems.subtask || 'Restoration',
    filmTitle: dropdownDetails.selectedTitle || '',
    reelName: dropdownDetails.selectedReel || '',
    empId: store.userStore.user?.roleName !== 'Admin' &&
    !store.commonStore.filterModeOne.includes('GA01')
      ? store?.userStore?.user?.displayName 
      : '',
    empName: dropdownDetails.selectedEmpName || ''
  }
    handleTableDetails(
      e,
      params
    );
    dashboardStore.setTagPageNumFunc(e);
    resetButtons();
    subtaskCompoent.isModel = false;
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading'
      // eslint-disable-next-line
      ? <LoadingComponent/> : <></>}
   {/* // eslint-disable-next-line */}
   <div className="newProductionPlanning-wrapper" style={{margin:'10px 0px'}}>
          <div>
          {templateL2Info?.length !== 0 && (
              <Menu
                style={{
                  padding: '5px',
                  height: '47px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                    {taskDetails.map(({ task, count }) => (
                    <button
                    style={{height:'10px'}}
                      className={
                        count === 0
                          ? 'disabled'
                          : selectedItems.task === task
                            ? 'selected'
                            : ''
                      }
                      onClick={() => {
                        resetButtons();
                        resetDropdown();
                        clickTaskHandler(task);
                        subtaskCompoent.isModel = false
                      }}
                      disabled={count === 0}
                    >{`${task} (${count})`}</button>
                  ))}
                </div>
              </Menu>
            )}
          </div>
        </div>

        <div className="newProductionPlanning-wrapper">
          {SubtaskDetails?.length !== 0 && (
              <Menu
              style={{
                padding: '5px',
                height: '47px',
              }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {!SubtaskDetails?.length ? (
                    <h4>Sorry No Data</h4>
                  ) : (
                    SubtaskDetails.map(({ subtask, count }) => (
                      <button
                        style={{ height: '10px' }}
                        onClick={() => {
                          resetButtons();
                          resetDropdown();
                          setPageNumber(1)
                          NFAI_Restoration_SmartflowsStore.selectedItems = { ...selectedItems,subtask }
                          statusButtonShow(-1);
                          subtaskCompoent.isModel = false
                          const params = {
                            taskName: selectedItems.task || 'Cutlist Restoration',
                            subtaskName: subtask || selectedItems.subtask || 'Restoration',
                            filmTitle: '',
                            reelName: '',
                            empId: store.userStore.user?.roleName !== 'Admin' &&
                            !store.commonStore.filterModeOne.includes('GA01')
                              ? store?.userStore?.user?.displayName 
                              : '',
                            empName: ''
                          }
                          handleTableDetails(
                            1,
                            params
                          );
                        }}
                        className={
                          count === 0
                            ? 'disabled'
                            : selectedItems.subtask === subtask
                              ? 'selected'
                              : ''
                        }
                        disabled={count === 0}
                      >{`${subtask} (${count})`}</button>
                    ))
                  )}
                </div>
                <InputAndButtonComponent setPageNumber={setPageNumber}/>
              </Menu>
            )}
        </div>
        <DynamicTableComponentForMetaData
          key={uuid()}
          data={titileInformation.details}
          name={'SmartTracker'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={pageNumber}
          searchFuncData={searchFunction}
        />
      {subtaskCompoent.isModel ? (
        <Segment>
         <SmarttrackerComponents/>
        </Segment>
      ) : null} 
    </div>
  );
};

export default observer(NFAI_Restoration_SmartFlow);
